// extracted by mini-css-extract-plugin
export default {"menuWrapper":"menu_menuWrapper__XTDMb","menuSection":"menu_menuSection__++yGM","menuInner":"menu_menuInner__Eg6Ry","content":"menu_content__PZDmF"};